import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  suggestions: [],
  history: [], // Last 2 days of meals
  favorites: [],
  loading: false,
  error: null,
  filters: {
    mealType: 'breakfast', // breakfast, lunch, dinner, etc.
    dietaryType: [], // veg, non-veg, jain
    cuisineStyle: [], // healthy, fried, kids-special
  },
};

const mealsSlice = createSlice({
  name: 'meals',
  initialState,
  reducers: {
    fetchSuggestionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuggestionsSuccess: (state, action) => {
      state.loading = false;
      state.suggestions = action.payload;
    },
    fetchSuggestionsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    addToHistory: (state, action) => {
      state.history.unshift(action.payload);
      // Keep only last 2 days of meals
      state.history = state.history.slice(0, 6); // Assuming 3 meals per day
    },
    toggleFavorite: (state, action) => {
      const mealId = action.payload;
      const index = state.favorites.indexOf(mealId);
      if (index === -1) {
        state.favorites.push(mealId);
      } else {
        state.favorites.splice(index, 1);
      }
    },
    skipMeal: (state, action) => {
      state.suggestions = state.suggestions.filter(
        meal => meal.id !== action.payload
      );
    },
  },
});

export const {
  fetchSuggestionsStart,
  fetchSuggestionsSuccess,
  fetchSuggestionsFailure,
  updateFilters,
  addToHistory,
  toggleFavorite,
  skipMeal,
} = mealsSlice.actions;

// Selectors
export const selectSuggestions = (state) => state.meals.suggestions;
export const selectHistory = (state) => state.meals.history;
export const selectFavorites = (state) => state.meals.favorites;
export const selectFilters = (state) => state.meals.filters;

export default mealsSlice.reducer;
